import { Tooltip } from '@cian/ui-kit';
import { Faq16 } from '@cian/ui-kit/prev';

import { type FC } from 'react';

export const AnyAvailableWorkspaceIcon: FC = () => {
  return (
    <Tooltip
      placement="right"
      theme="white"
      title={
        <>
          Любое доступное рабочее
          <br />
          место в общей зоне
        </>
      }
    >
      {/* @todo заменить на иконку из макета, в ките нет, генерация иконок сломана, ждём, пока починят */}
      <Faq16 />
    </Tooltip>
  );
};
